import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Label, Input } from 'reactstrap';
import LoaderButton from '../loader-button/LoaderButton';
import Switch from 'react-switch';

const TenantSettingsModal = ({ modalOpen, setModalOpen, setting, onSave, isLoading }) => {
  const [value, setValue] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    if (setting && modalOpen) {
      if (setting.value?.type === 'boolean') {
        setValue(!!setting.value?.value);
      } else {
        setValue(setting.value?.value || '');
      }
      setIsSubmitted(false);
    }
  }, [setting, modalOpen]);

  const handleClose = () => {
    setModalOpen(false);
    setIsSubmitted(false);
  };

  const handleSave = () => {
    if (validateInput()) {
      onSave(setting.id, value);
    } else {
      setIsSubmitted(true);
    }
  };
  const validateInput = () => {
    if (!setting?.value?.type) return false;

    switch (setting.value.type) {
      case 'string':
        return value.toString().trim().length > 0;
      case 'boolean':
        return typeof value === 'boolean';
      default:
        return false;
    }
  };

  const renderValueInput = () => {
    if (!setting?.value?.type) return null;

    if (setting.value.type === 'boolean') {
      return (
        <FormGroup>
          <Label>Value</Label>
          <div className="mt-2">
            <Switch
              checked={value}
              onChange={setValue}
              onColor="#86d3ff"
              onHandleColor="#2693e6"
              handleDiameter={20}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={15}
              width={35}
              className="react-switch"
            />
            <span className="ml-2">{value ? 'Enabled' : 'Disabled'}</span>
          </div>
        </FormGroup>
      );
    }

    if (setting.value.type === 'string') {
      return (
        <FormGroup>
          <Label>Value *</Label>
          <Input
            type="text"
            value={value}
            onChange={e => setValue(e.target.value)}
            placeholder="Enter value..."
            invalid={isSubmitted && !validateInput()}
          />
          {isSubmitted && !validateInput() && (
            <div className="invalid-feedback d-block">Please enter a valid value</div>
          )}
        </FormGroup>
      );
    }

    return null;
  };

  if (!setting) return null;

  return (
    <Fragment>
      <Modal isOpen={modalOpen} toggle={handleClose} size="md">
        <ModalHeader toggle={handleClose}>Edit Tenant Setting: {setting.label}</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Setting ID</Label>
            <Input type="text" value={setting.id} disabled />
          </FormGroup>
          <FormGroup>
            <Label>Label</Label>
            <Input type="text" value={setting.label} disabled />
          </FormGroup>
          <FormGroup>
            <Label>Type</Label>
            <Input type="text" value={setting.value?.type || ''} disabled />
          </FormGroup>
          {renderValueInput()}
        </ModalBody>
        <ModalFooter>
          <Button color="falcon-danger" onClick={handleClose}>
            Cancel
          </Button>
          <LoaderButton color="falcon-primary" onClick={handleSave} isLoading={isLoading} name="save-setting">
            Save Setting
          </LoaderButton>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

TenantSettingsModal.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  setModalOpen: PropTypes.func.isRequired,
  setting: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.shape({
      type: PropTypes.oneOf(['string', 'boolean']).isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    }).isRequired
  }),
  onSave: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};

TenantSettingsModal.defaultProps = {
  isLoading: false,
  setting: null
};

export default TenantSettingsModal;
